<style lang='scss' scoped>
.dashborad {
  .dashborad-item {
    color: #fff;
    font-size: 24px;
    float: left;
    width: 50%;
    background-color: #2d8cf0;
    padding: 30px 0;
    margin-bottom: 20px;
    header {
      font-size: 50px;
      line-height: 2;
    }
  }
}
</style>


<template>
    <section class="dashborad">
        <article class="clearfix text-center">
            <div class="dashborad-item">
                <footer>{{$t('fbb.bill.account_available', { defaultValue: '可用余额' })}}</footer>
                <header>{{data.availableAmount|tofixed}} USD    <span style="font-size: 16px;"><a href="/home/bill/transaction/list" style="color: #fff;">{{$t('fbb.account.see_availnum', { defaultValue: '查看扣款' })}}</a> | <a href="#" style="color: #fff;">{{$t('fbb.account.save_voice', { defaultValue: '设置预警' })}}</a></span></header>
            </div>
            <div class="dashborad-item">
                <footer>{{$t('fbb.bill.frozen_amount', { defaultValue: '冻结金额' })}}<img src=""/></footer>
                <header>{{data.freezeTotalAmount|tofixed}} USD    <span style="font-size: 16px;"><a href="/home/bill/freeze" style="color: #fff;">{{$t('fbb.bill.frozen_see', { defaultValue: '查看冻结' })}}</a></span></header>
            </div>
            <div class="dashborad-item" style="width:100%;">
                <footer>{{$t('fbb.bill.line_credit', { defaultValue: '信用额度' })}}</footer>
                <header>{{data.creditQuota|tofixed}} USD   =   
                    <span style="font-size: 24px;font-weight: 800;"> {{data.totalQuota|tofixed}} USD({{$t('fbb.bill.total_combination', { defaultValue: '总额度' })}})  -   {{data.useQuota|tofixed}} USD({{$t('fbb.bill.have_limit', { defaultValue: '已用额度' })}})</span>
                </header>
            </div>
            <div class="dashborad-item" style="background-color:#fc8627;margin-right: 8%;width: 46%;">
                <footer>{{$t('fbb.bill.nowmonth_totalRevenue', { defaultValue: '本月总收入' })}}</footer>
                <header>{{data.totalRevenue|tofixed}} USD</header>
            </div>
            <div class="dashborad-item" style="background-color:#32cc7f;width: 46%;">
                <footer>{{$t('fbb.bill.nowmonth_totalExpenses', { defaultValue: '本月总支出' })}}</footer>
                <header>{{data.totalExpenses|tofixed}} USD</header>
            </div>
        </article>
    
    </section>
</template>

<script>
import { HttpAccountInfo } from "@/service/account";
export default {

    data() {
        return {
            data: {},

        };
    },
    created() {
        this.getOverview();
    },
    filters:{
        tofixed(val){
            return parseFloat(val||0).toFixed(2);
        }
    },

    methods: {
        async getOverview() {
            HttpAccountInfo().then(res => {
                this.data = res.data;
            }, err => {

            })
        },
    },
};
</script>



